import { render, staticRenderFns } from "./Icon_styles.vue?vue&type=template&id=12171737&scoped=true"
import script from "./Icon_styles.vue?vue&type=script&lang=js"
export * from "./Icon_styles.vue?vue&type=script&lang=js"
import style0 from "./Icon_styles.vue?vue&type=style&index=0&id=12171737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12171737",
  null
  
)

export default component.exports